export enum SystemMessageTypeEnum {
  UserMessage,
  SystemMaintence,
}
